const tableCellVerification = {
  Typography: '¿Realmente desea eliminar este elemento?',
  editSwitchYes: 'Sí',
  editSwitchNo: 'No'
};

export default tableCellVerification;
